"use client";

import React from "react";
import { useRef } from "react";
import Image from "next/image";

const PartnerImage = ({ name }: { name: string }) => {
  return (
    <div
      className="w-full mx-3 mt-2 relative"
      style={{
        height: 50,
        width: 100,
      }}
    >
      <Image
        unoptimized
        className="object-contain object-center w-full h-full"
        id={`partnerlogo-${name}`}
        src={`/images/mentoring/${name}.png`}
        alt={`Partner Logo - ${name}`}
        key={`image-number-${name}`}
        fill
      />
    </div>
  );
};

const MenteeGrid = () => {
  const PartnersList = useRef([
    "amazon",
    "fp",
    "adpl",
    "shop",
    "gojek",
    "toped",
    "tiket",
    "unlvr",
    "waterloo",
    "ui",
    "itb",
    "binus",
  ]);
  return (
    <div className="w-full grid grid-cols-3 gap-x-0 gap-y-3 md:gap-3">
      {PartnersList.current.map((partner) => (
        <PartnerImage name={partner} key={partner} />
      ))}
    </div>
  );
};

export default MenteeGrid;
